import { api } from "./index";

export interface LoginAsUserRequest {
    user_id: number;
}

export interface LoginAsUserResponse {
    success: boolean;
    url: string;
    user: {
        id: number;
        name: string;
        surname: string;
        email: string;
        ref_link: string;
    };
}

export const crossAuthApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getClientCabinetUrl: builder.query<{ url: string }, void>({
            query: () => "/cross-auth/client-cabinet-url",
        }),
        loginAsUser: builder.mutation<LoginAsUserResponse, LoginAsUserRequest>({
            query: (data) => ({
                url: "/cross-auth/login-as-user",
                method: "POST",
                body: data,
            }),
        }),
    }),
});

export const { useGetClientCabinetUrlQuery, useLoginAsUserMutation } =
    crossAuthApi;
